import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { compose } from 'redux';
import { Semiology } from '../../../model/semiology/semiology';
import { IRootState } from '../../../reducer';
import SemiologyService from '../../../services/semiologyService';
import './components.scss';

interface Props extends RouteComponentProps<{}> {
    t: (path: string, param?: any) => string;
    history: any;
}

const FreeSemiologies = (props: Props) => {
    const [semiologies, setSemiologies] = useState<Semiology[]>([]);

    useEffect(() => {
        SemiologyService.getAvailableForFree()
            .then(response => setSemiologies(response));
    }, []);

    return (
        <div className="component">
            <h1 className="component__title">{props.t('preferences.freeSemiologiesComponent.title')}</h1>
            <div className="component__content">
                {semiologies && semiologies.map((it, index) => (
                    <a key={index} className="component__card-item" href={`/semiology/${it.id}`}>
                        <div className="component__card-item__content">
                            <div className="component__card-item__content__row">
                                <span className="component__card-item__label">{it.name}</span>
                                <div className="arrow-right-img" />
                            </div>
                        </div>
                        <div className="component__card-item__extension" />
                    </a>
                ))}
            </div>
        </div>
    );
}

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = {};

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(FreeSemiologies) as React.ComponentType<any>;
